import { FC } from 'react';
import Chip from '.';
import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

interface Props {
  notAvailable?: boolean;
  system?: boolean;
  redact?: boolean;
  length?: number;
  hint?: string;
}

const useStyles = createUseStyles<string, { redact: boolean }>((theme: Theme) => ({
  noneChip: {
    opacity: 0.5,
    border: `1px dashed ${theme.palette.chip.outline}`,
    background: 'none',
    '& .MuiChip-label': {
      paddingTop: ({ redact }) => (redact ? 7 : 0),
    },
  },
}));

const NoneChip: FC<Props> = ({ notAvailable, system, redact = false, length = 8, hint = '' }) => {
  const styles = useStyles({ redact: redact && !hint.length });

  let label = 'none';

  if (notAvailable) {
    label = 'n/a';
  }

  if (system) {
    label = 'System';
  }

  if (redact) {
    label = '*'.repeat(length - hint.length) + hint;
  }

  return <Chip label={label} size="small" className={styles.noneChip} />;
};

export default NoneChip;
